<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <img :src="orderType.icon" width="25" />
      </span>
    </template>
    <span>{{ orderType.label }}</span>
  </v-tooltip>
</template>
<script>
  export default {
    name: 'SpecialOrderTypeIcon',
    props: {
      order: {
        type: String,
        required: true,
      },
      cancelled: {
        type: String,
        default: '',
      },
    },
    computed: {
      orderType: function () {
        const type = this.cancelled === 'C' ? 'C' : this.order;
        switch (type) {
          case 'PSPO':
            return {
              icon: require(`@/assets/img/icons_orders/POP.svg`),
              label: 'Bono POP',
            };
          case 'PSNW':
            return {
              icon: require(`@/assets/img/icons_orders/PNC.svg`),
              label: 'Productos Nuevos',
            };
          case 'ZAIU':
            return {
              icon: require(`@/assets/img/icons_orders/A.svg`),
              label: 'Factura de Anticipo',
            };
          case 'G2R':
            return {
              icon: require(`@/assets/img/icons_orders/BR.png`),
              label: 'Bono Rebate',
            };
          case 'REX':
          case 'C':
            return {
              icon: require(`@/assets/img/icons_orders/C.svg`),
              label: 'Factura Cancelada',
            };
          case 'PSPP':
            return {
              icon: require(`@/assets/img/icons_orders/POP.svg`),
              label: 'Bono Servicios POP',
            };
          case 'VENCIDO':
            return {
              icon: require(`@/assets/img/icons_orders/V.svg`),
              label: 'Vencido',
            };
          case 'POR VENCER':
            return {
              icon: require(`@/assets/img/icons_orders/current.svg`),
              label: 'Corriente',
            };
          default:
            return { icon: '', label: '' };
        }
      },
    },
  };
</script>
